// src/components/Navbar.js

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Clock from "./Clock";

const Navbar = ({ onLogout }) => {
  const location = useLocation();
  const [isMenuOpen, setMenuOpen] = useState(false);

  // Updated navItems now include "Iana's SimZone"
  const navItems = [
    { label: "Mai Miku Atelier", to: "/" },
    { label: "Kara's Workouts", to: "/karas-workouts" },
    { label: "Violet's Dream Journal", to: "/violet-dream-journal" },
    { label: "ChatGPT's News", to: "/chatgpts-news" },
    { label: "Iana's SimZone", to: "/iana-simzone" },
  ];

  // Determine current link & others
  const currentItem =
    navItems.find((item) => item.to === location.pathname) || navItems[0];
  const otherItems = navItems.filter((item) => item.to !== currentItem.to);

  return (
    <nav className="bg-gray-900 px-4 py-4 md:px-12">
      {/* DESKTOP NAVBAR */}
      <div className="hidden md:flex items-center justify-between">
        {/* Left: All nav links */}
        <div className="flex space-x-6">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`text-xl font-bold ${
                location.pathname === item.to
                  ? "text-white underline"
                  : "text-[#137a7f]"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
        {/* Right: Clock and Logout button */}
        <div className="flex items-center space-x-4">
          <Clock />
          <button
            onClick={onLogout}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 text-xl font-bold"
          >
            Logout
          </button>
        </div>
      </div>

      {/* MOBILE NAVBAR */}
      <div className="md:hidden flex items-center justify-between">
        <span className="text-xl font-bold text-white">{currentItem.label}</span>
        <div className="flex items-center space-x-4">
          <Clock />
          <button
            onClick={() => setMenuOpen(!isMenuOpen)}
            className="text-white focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* MOBILE MENU */}
      {isMenuOpen && (
        <div className="md:hidden mt-4 space-y-4">
          {otherItems.map((item) => (
            <Link
              key={item.to}
              onClick={() => setMenuOpen(false)}
              to={item.to}
              className="block text-xl font-bold text-[#137a7f]"
            >
              {item.label}
            </Link>
          ))}
          <button
            onClick={() => {
              setMenuOpen(false);
              onLogout();
            }}
            className="w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 text-xl font-bold"
          >
            Logout
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
